import React from 'react';
import ReactGA from 'react-ga';
import { Switch, Route, Link } from 'react-router-dom';
import Home from './Components/Home/Home';
import Success from './Components/Success/Success';
import PartnerHome from './Components/PartnerPortal/PartnerHome/PartnerHome';
import CutsomerRequests from './Components/CustomerRequests/CustomerRequests';
import Postal from './Components/Home/Postal';

ReactGA.initialize('UA-2652518-1');
ReactGA.pageview('requestportal' + window.location.pathname);

const App = () => {
    return (
        <Switch>
            <Route exact path='/'>
                <Home />
                {/* <Postal /> */}
            </Route>
            <Route exact path='/success'>
                <Success />
            </Route>
            <Route exact path='/customer_requests'>
                <CutsomerRequests />
            </Route>
            <Route exact path='/partner_home'>
                <PartnerHome />
            </Route>
        </Switch>
    );
};

export default App;
